import React, { useState } from "react";
import Helmet from "react-helmet";
import { AppName, CleanMessage } from "../../../../util/app";
import FabButton from "../../../../partials/Buttons/FabButton";
import NewWaterLow from "./NewItem";
import { useQuery, useMutation } from "react-apollo";
import { GET_WATERLOW_LIST, NEW_WATERLOW, CONFIRM_WATERLOW } from "../../../../queries/waterlow.query";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../../partials/loading";
import WaterlowList from "./WaterlowList";
import { ReadData } from "../../../../providers/Patient.Provider";
import WaterlowDetail from "./WaterlowDetail";

const WaterFlowPressure = ({ match }) => {
    const [newItem, setNewItem] = useState(false);
    const [item, setItem] = useState();

    const { id } = match.params;

    const patient = ReadData();

    const scrollTOp = () => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    };

    // QUERY
    const { loading, data } = useQuery(GET_WATERLOW_LIST, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        variables: { id },
    });
    // MUTATION
    const [createFunc, { loading: cLoading }] = useMutation(NEW_WATERLOW, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            const { message } = d.NewWaterlowPressureUlcerAssessment;
            toast.success(message);
            setNewItem(false);
            setItem(null);
            scrollTOp();
        },
        update: (cache, { data }) => {
            // GET
            const { GetWaterlowPressureUlcerAssessments } = cache.readQuery({
                query: GET_WATERLOW_LIST,
                variables: { id },
            });
            // Update object
            GetWaterlowPressureUlcerAssessments.docs.unshift(data.NewWaterlowPressureUlcerAssessment.doc);
            // Update cache
            cache.writeQuery({
                query: GET_WATERLOW_LIST,
                variables: { id },
                data: {
                    GetWaterlowPressureUlcerAssessments,
                },
            });
        },
    });

    // MUTATION CONFIRM
    const [confirmFunc, { loading: uLoading }] = useMutation(CONFIRM_WATERLOW, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            const { message } = d.ConfirmWaterlowPressureUlcer;
            toast.success(message);
        },
    });
    const title = "Waterlow Pressure Ulcer Prevention";
    return (
        <>
            <Helmet>
                <title>
                    {title} | {AppName}
                </title>
            </Helmet>

            <div className="row">
                {!newItem && !item && (
                    <div className="col-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>{title}</header>
                            </div>
                            <div className="card-body" style={{ minHeight: "520px" }}>
                                <div className="col-12">
                                    <LoadingSpinner loading={loading || uLoading} />
                                </div>
                                {!loading && data && (
                                    <WaterlowList
                                        onView={(i) => {
                                            setNewItem(false);
                                            setItem(i);
                                            scrollTOp();
                                        }}
                                        onConfirm={async (item) => {
                                            if (window.confirm("Are you sure you want  to proceed?")) {
                                                await confirmFunc({ variables: { id: item.id } });
                                            }
                                        }}
                                        items={data.GetWaterlowPressureUlcerAssessments.docs}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {newItem && !item && (
                <div className="col fade-in">
                    <div className="card">
                        <div className="card-head">
                            <header>
                                {" "}
                                <button
                                    onClick={() => {
                                        setNewItem(false);
                                        setItem(null);
                                        scrollTOp();
                                    }}
                                    title="Back"
                                    className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                >
                                    <i className="material-icons text-primary">keyboard_backspace</i>
                                </button>
                                New {title}
                            </header>
                        </div>
                        <div className="card-body">
                            <NewWaterLow
                                onCancel={() => {
                                    setNewItem(false);
                                    setItem(null);
                                    scrollTOp();
                                }}
                                onSubmit={async ({ model, confirm }) => {
                                    await createFunc({ variables: { model: { ...model, patient: id, admission: patient.lastAdmission }, confirm } });
                                }}
                            />
                            <LoadingSpinner loading={cLoading} />
                        </div>
                    </div>
                </div>
            )}
            {/* DETAIL */}
            {!newItem && item && (
                <div className="col fade-in">
                    <div className="card">
                        <div className="card-head">
                            <header>
                                <button
                                    onClick={() => {
                                        setNewItem(false);
                                        setItem(null);
                                        scrollTOp();
                                    }}
                                    title="Back"
                                    className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                >
                                    <i className="material-icons text-primary">keyboard_backspace</i>
                                </button>
                                {title} Detail
                            </header>
                        </div>
                        <div className="card-body">
                            <WaterlowDetail item={item} />
                        </div>
                    </div>
                </div>
            )}
            {!newItem && (
                <div className="fade-in">
                    <FabButton
                        onClick={() => {
                            setNewItem(true);
                            setItem(null);
                            scrollTOp();
                        }}
                        title={"New " + title}
                    />
                </div>
            )}
        </>
    );
};

export default WaterFlowPressure;
